/*eslint-disable*/
import {englishAndRussian, bulgarian, ukrainian, french, latvian} from '../../../config/minDurationsForVoiceActing';

export default {
    computed: {
        showDisplaySpeedHelpText () {
            return this.params.speed < this.getLanguageSpeed && this.params.extraOptions.voiceOver;
        },
        showDisplaySpeedIncreasingHelpText () {
            let amountOfVoiceOverExamples = (((this.params.speed - this.getLanguageSpeed) / this.params.speedUp + 1) * this.params.tasksForSpeedUp).toFixed(0);
            if (amountOfVoiceOverExamples >= this.params.amountOfExamples || this.showDisplaySpeedHelpText || !this.params.extraOptions.voiceOver) {
                return 0;
            } else {
                return amountOfVoiceOverExamples;
            }
        },
        getLanguageSpeed () {
            let languageSpeed = this.minDurationForVoiceActing;
            if (this.params.difficult === 1 || this.params.difficult === 'Однозначные цифры') {
                return languageSpeed[1];
            }
            if (this.params.difficult === 2 || this.params.difficult === 'Двузначные цифры') {
                return languageSpeed[2];
            }
            if (this.params.difficult === 3 || this.params.difficult === 'Трехзначные цифры') {
                return languageSpeed[3];
            }
            if ((this.params.difficult === 4 || this.params.difficult === 'Четырехзначные цифры') && languageSpeed[4]) {
                return languageSpeed[4];
            }
            if ((this.params.difficult === 5 || this.params.difficult === 'Пятизначные цифры') && languageSpeed[5]) {
                return languageSpeed[5];
            }
            return 0;
        },
        minDurationForVoiceActing () {
            if (this.user && this.user.locale === 'bg') {
                return bulgarian;
            } else if (this.user && this.user.locale === 'uk') {
                return ukrainian;
            } else if (this.user && this.user.locale === 'fr') {
                return french;
            } else if (this.user && this.user.locale === 'lv') {
                return latvian;
            }   else {
                return englishAndRussian;
            }
        }
    }
}
